"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERCOM_EMAIL_TOKEN = exports.INTERCOM_HASH_TOKEN = exports.SENTRY_TAG_TOKEN = exports.SENTRY_DSN_TOKEN = exports.SESSION_TOKEN_EXPIRY = exports.SESSION_TOKEN = exports.USERID_TOKEN = exports.AMPLITUDE_TOKEN = exports.HANDOVER_TOKEN = void 0;
exports.HANDOVER_TOKEN = 'token';
exports.AMPLITUDE_TOKEN = 'analytics';
exports.USERID_TOKEN = 'userId';
exports.SESSION_TOKEN = 'greywing-session';
exports.SESSION_TOKEN_EXPIRY = exports.SESSION_TOKEN + ':expiry';
exports.SENTRY_DSN_TOKEN = 'dsn';
exports.SENTRY_TAG_TOKEN = 'tag';
exports.INTERCOM_HASH_TOKEN = 'icHash';
exports.INTERCOM_EMAIL_TOKEN = 'icEmail';
